import { TEMPLATES_TRACKING_EDITOR } from 'src/constants/templates';

export const trackingList = (templateTitle, button1, button2) => {
  const tracking_editor = TEMPLATES_TRACKING_EDITOR?.[templateTitle];

  let button1_list = '[';
  for (let i = 0; i < tracking_editor?.length; i++) {
    button1_list += `${JSON.stringify(
      button1?.[tracking_editor[i]] === undefined
        ? []
        : button1?.[tracking_editor[i]]
    )},`;
  }
  button1_list += ']';

  let button2_list = '[';
  for (let i = 0; i < tracking_editor?.length; i++) {
    button2_list += `${JSON.stringify(
      button2?.[tracking_editor[i]] === undefined
        ? []
        : button2?.[tracking_editor[i]]
    )},`;
  }
  button2_list += ']';

  return [button1_list, button2_list];
};
